import type { ReactNode } from "react";
import { Headset } from "lucide-react";

export function SdAuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#dce9f6]">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.22]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgb(51 65 85 / 0.3) 1px, transparent 0)",
          backgroundSize: "24px 24px",
        }}
      />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_75%_at_50%_42%,#f0f7ff_0%,#dce9f6_72%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(37,99,235,0.12),transparent_55%)]" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-slate-200/15" />

      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-10 sm:px-6">
        <div className="w-full max-w-[420px]">
          <header className="mb-7 text-center">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-600 text-white">
              <Headset className="h-7 w-7" strokeWidth={1.75} aria-hidden />
            </div>
            <h1 className="mt-5 text-[1.65rem] font-bold tracking-tight text-slate-900">
              ServiceDesk
            </h1>
            <p className="mt-1.5 text-sm text-blue-950/50">
              IT Service Management Platform
            </p>
          </header>

          <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
            <div className="h-0.5 w-full bg-blue-600" aria-hidden />
            <div className="p-6 sm:p-8">{children}</div>
          </div>

          <p className="mt-6 text-center text-xs text-slate-400">
            © {new Date().getFullYear()} Universal Software
          </p>
        </div>
      </div>
    </div>
  );
}

export const sdAuthInputClassName =
  "h-12 w-full rounded-xl border border-slate-200 bg-[#eff6ff] pl-11 pr-4 text-[15px] text-slate-900 " +
  "placeholder:text-slate-400 outline-none transition-all duration-200 " +
  "hover:border-slate-300 hover:bg-white focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-500/10";

export const sdAuthLabelClassName =
  "mb-2 block text-[13px] font-medium text-slate-600";

export const sdAuthPrimaryButtonClassName =
  "mt-1 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-blue-600 " +
  "px-4 text-[15px] font-semibold text-white transition-all duration-200 " +
  "hover:bg-blue-700 active:scale-[0.99] " +
  "disabled:pointer-events-none disabled:opacity-60";
